import { IBenefitFallbacksResponse } from "types/BenefitFallbacks/BenefitFallbacks";

import { api } from ".";

/**
 * CLE-3013 — Eligibility › Fallbacks: every hospital's live benefit map rows, READ ONLY.
 * SuperAdmin only on the API. Nothing here writes; the rows change when a hospital's benefit
 * selection screen is saved or the map is re-seeded, so the tab refetches each time it is opened
 * (`refetchOnMountOrArgChange` at the call site) rather than relying on another screen's tags.
 */
const apiWithBenefitFallbackTags = api.enhanceEndpoints({
  addTagTypes: ["BenefitFallbacks"],
});

export const BENEFIT_FALLBACKS_PATH = "eligibility/benefit-fallbacks";

export const benefitFallbackQueries =
  apiWithBenefitFallbackTags.injectEndpoints({
    endpoints: (builder) => ({
      getBenefitFallbacks: builder.query<IBenefitFallbacksResponse, void>({
        query: () => BENEFIT_FALLBACKS_PATH,
        transformResponse: (response: { data: IBenefitFallbacksResponse }) =>
          response.data,
        providesTags: [{ type: "BenefitFallbacks", id: "LIST" }],
      }),
    }),
  });

export const { useGetBenefitFallbacksQuery } = benefitFallbackQueries;
